import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { humanize } from 'underscore.string';
import { cn } from 'utils/ui/classes';
function getColor(legType) {
    const key = legType.toLowerCase().replace(/[\s-]+/g, '_');
    switch (key) {
        case 'full_container':
            return 'bg-blue-100 text-blue-800 border-blue-300';
        case 'empty_container':
            return 'bg-green-100 text-green-800 border-green-300';
        case 'chassis_split':
            return 'bg-purple-100 text-purple-800 border-purple-300';
        case 'bobtail':
            return 'bg-yellow-100 text-yellow-800 border-yellow-300';
        case 'dry_run':
            return 'bg-indigo-100 text-indigo-800 border-indigo-300';
        default:
            return 'bg-gray-100 text-gray-800 border-gray-300';
    }
}
export default function LegTypeBadge({ className = '', legType, label, }) {
    if (!legType)
        return null;
    return (React.createElement(Badge, { variant: "outline", className: cn('whitespace-nowrap self-start shrink-0 grow-0', getColor(legType), className) }, label !== null && label !== void 0 ? label : humanize(legType)));
}
